import {
  deriveLogoChurnFromCurve,
  effectiveMonthlyChurn,
  normalizeRetention,
} from '../model/cohorts';

export default function CohortsPanel({ cohorts, onChange }) {
  const retention = normalizeRetention(cohorts.retention);
  const churnRates = deriveLogoChurnFromCurve(retention);
  const steadyChurn = effectiveMonthlyChurn(retention);

  const updateRetention = (index, value) => {
    const next = [...retention];
    next[index] = Math.min(1, Math.max(0, parseFloat(value) || 0));
    if (index === 0) next[0] = 1;
    onChange({ retention: normalizeRetention(next) });
  };

  return (
    <section className="chart-card economics-panel">
      <h2>Cohort retention</h2>
      <p className="chart-hint">
        Editable M0–M12 cumulative retention → derived logo churn. Steady-state monthly churn ≈{' '}
        <strong>{(steadyChurn * 100).toFixed(1)}%</strong>
      </p>

      <div className="table-scroll">
        <table className="data-table">
          <thead>
            <tr>
              <th>Month</th>
              <th>Retention</th>
              <th>Monthly churn</th>
            </tr>
          </thead>
          <tbody>
            {retention.map((r, i) => (
              <tr key={i}>
                <td>M{i}</td>
                <td>
                  {i === 0 ? (
                    '100%'
                  ) : (
                    <input
                      type="number"
                      min="0"
                      max="100"
                      step="1"
                      className="economics-inline-input"
                      value={Math.round(r * 1000) / 10}
                      onChange={(e) => updateRetention(i, parseFloat(e.target.value) / 100)}
                    />
                  )}
                </td>
                <td>{i === 0 ? '—' : `${((churnRates[i - 1] || 0) * 100).toFixed(1)}%`}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </section>
  );
}
